/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityMenu.vue?vue&type=template&id=b402f8f8&scoped=true"
import script from "./cityMenu.vue?vue&type=script&lang=js"
export * from "./cityMenu.vue?vue&type=script&lang=js"
import style0 from "./cityMenu.vue?vue&type=style&index=0&id=b402f8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b402f8f8",
  null
  
)

export default component.exports